export const initialState = {
  quiz: {
    unAnswered: [],
    answered: [],
  },
};
